export default "__VITE_ASSET__BFYZflTj__"